'use client';

import React from 'react';
import SlideWrapper from '../SlideWrapper';
import { Utensils, Zap, Play, Hammer, Heart } from 'lucide-react';

interface Props {
  id: string;
  registerRef: (id: string, el: HTMLElement | null) => void;
}

const activities = [
{
  icon: <Utensils size={18} className="text-[#e8a030]" />,
  time: '07:00 – 08:00',
  title: 'Ăn sáng',
  desc: 'Bữa sáng khởi đầu ngày mới.',
  accent: '#e8a030'
},
{
  icon: <Zap size={18} className="text-[#4caf7d]" />,
  time: '08:00 – 11:30',
  title: 'Xây dựng khu vượt chướng ngại vật thiên nhiên',
  desc: 'Dựng vật cản, xác định tuyến, đảm bảo an toàn và hoàn thiện khu vận động.',
  accent: '#4caf7d'
},
{
  icon: <Utensils size={18} className="text-[#e8a030]" />,
  time: '11:30 – 13:00',
  title: 'Ăn trưa – nghỉ ngơi',
  desc: 'Bữa trưa và thời gian nghỉ ngơi phục hồi năng lượng.',
  accent: '#e8a030'
},
{
  icon: <Play size={18} className="text-[#f5c96a]" />,
  time: '13:30 – 15:00',
  title: 'Vận hành thử toàn bộ khu trải nghiệm',
  desc: 'Test khu dòng nước, khu báu vật, cầu tầm vông và khu vận động.',
  accent: '#f5c96a'
},
{
  icon: <Hammer size={18} className="text-[#a8d87a]" />,
  time: '15:00 – 17:30',
  title: 'Hoàn thiện cầu tầm vông (giai đoạn 2)',
  desc: 'Gia cố, chỉnh form, hoàn thiện và dọn dẹp trước khi bàn giao.',
  accent: '#a8d87a'
},
{
  icon: <Utensils size={18} className="text-[#e8a030]" />,
  time: '17:30 – 19:00',
  title: 'Ăn tối – sinh hoạt cá nhân',
  desc: 'Bữa tối và thời gian tự do cá nhân.',
  accent: '#e8a030'
},
{
  icon: <Heart size={18} className="text-[#4caf7d]" />,
  time: '19:00 – 21:30',
  title: 'Đêm chia sẻ thật',
  desc: 'Chia sẻ sâu về hành trình và sự thay đổi cá nhân.',
  accent: '#4caf7d'
}];


export default function Slide12dDay5({ id, registerRef }: Props) {
  return (
    <SlideWrapper id={id} registerRef={registerRef} className="bg-[#0a1a0f]">
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1734261781792-fc60d6f8350d"
          alt="Thiên nhiên hoang dã Việt Nam, đồng cỏ xanh mướt trải dài dưới bầu trời trong xanh"
          className="w-full h-full object-cover opacity-8" />
        
        <div className="absolute inset-0 bg-gradient-to-br from-[#1a3a2a]/70 via-[#0a1a0f] to-[#0a1a0f]" />
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[rgba(76,175,125,0.3)] to-transparent" />
      </div>

      <div className="relative z-10 max-w-screen-xl mx-auto px-6 lg:px-16 xl:px-24 py-24 pt-28 min-h-screen flex flex-col justify-center">
        <div className="fade-in-up mb-4">
          <div className="chapter-badge">
            <span className="w-1.5 h-1.5 rounded-full bg-[#4caf7d] inline-block" />
            Hành trình 8 ngày 7 đêm
          </div>
        </div>

        <div className="fade-in-up mb-3">
          <h2 className="font-display font-800 text-[clamp(24px,3.5vw,48px)] leading-[1.1] text-[#f0ede6] tracking-tight">
            NGÀY 5
          </h2>
          <h2 className="font-display font-800 text-[clamp(18px,2.5vw,32px)] leading-[1.3] tracking-tight text-gradient-green">
            Vượt chướng ngại – Vận hành – Chia sẻ thật
          </h2>
        </div>

        <div className="fade-in-up mb-8">
          <div className="section-divider" />
        </div>

        <div className="relative fade-in-up">
          <div className="absolute left-[22px] top-0 bottom-0 w-px bg-gradient-to-b from-[#4caf7d]/60 via-[#f5c96a]/40 to-transparent" />
          <div className="flex flex-col gap-4">
            {activities.map((act, i) =>
            <div key={`d5-${i}`} className="flex items-start gap-4 pl-2">
                <div
                className="flex-shrink-0 w-9 h-9 rounded-full flex items-center justify-center z-10"
                style={{ background: `${act.accent}22`, border: `1.5px solid ${act.accent}55` }}>
                
                  {act.icon}
                </div>
                <div
                className="flex-1 rounded-xl p-4 transition-all duration-300 hover:-translate-y-0.5"
                style={{ background: `${act.accent}0d`, border: `1px solid ${act.accent}22` }}>
                
                  <div className="flex flex-wrap items-center gap-2 mb-1">
                    <span
                    className="font-body font-700 text-[11px] tabular-nums px-2 py-0.5 rounded-full"
                    style={{ color: act.accent, background: `${act.accent}18` }}>
                    
                      {act.time}
                    </span>
                    <h3 className="font-display font-700 text-[14px] lg:text-[15px] text-[#f0ede6]">
                      {act.title}
                    </h3>
                  </div>
                  <p className="font-body text-[12px] lg:text-[13px] text-[#a0b8a8] leading-relaxed">
                    {act.desc}
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </SlideWrapper>);

}